import { getValidationResolver, useForm } from '@common-fe/common-fe';

import { VALIDATORS } from '@/common';

import { CreatePayoutDefinitionFormValues } from '../CreatePayoutDefinitionModal.types';

const useCreatePayoutDefinitionForm = () => {
  const methods = useForm<CreatePayoutDefinitionFormValues>({
    defaultValues: {
      name: '',
      copyFromId: '',
    },
    resolver: getValidationResolver({
      name: VALIDATORS.REQUIRED_STRING,
    }),
  });

  return { methods };
};

export default useCreatePayoutDefinitionForm;
